import { colors } from 'app-v2/design-systems/theme'
import { Close } from 'app/assets/icons'
import { media } from 'app/assets/styles/breakpoints'
import { Text } from 'app/common/typography'
import React, { useEffect } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import styled from 'styled-components'

type Props = {
    authenticated: boolean,
    isCartToastVisible: boolean,
    setCartToast: boolean => void
}

export const CartToast = ({ isCartToastVisible, setCartToast }: Props) => {
    useEffect(() => {
        setTimeout(() => {
            if (isCartToastVisible) {
                setCartToast(false)
            }
        }, 4000)
    }, [isCartToastVisible, setCartToast])

    return (
        isCartToastVisible && (
            <StyledView onClick={() => setCartToast(false)}>
                <Center>
                    <FormattedMessage id="clickandcollect.carttoast.addProduct">
                        {(text: string) => <StyledText>{text}</StyledText>}
                    </FormattedMessage>
                </Center>
                <CloseContainer>
                    <Close color={colors.lightMayo} size={20} />
                </CloseContainer>
            </StyledView>
        )
    )
}

const StyledText = styled(Text)`
    margin-top: 3px;
    color: ${colors.lightMayo};
    text-align: center;
`

const StyledView = styled.div`
    position: absolute;
    bottom: 46px;
    padding-bottom: 30px;
    ${media.xsmall`
        padding-bottom: 42px
    `}
    ${media.small`
        padding-bottom: 52px;
    `}
    ${media.medium`
        padding-bottom: 60px;
    `}
    width: 100%;
    background-color: ${colors.crunchyGreen};
`

const Center = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
`

const CloseContainer = styled.div`
    flex-direction: row;
    right: 10px;
    margin-top: -26px;
    ${media.medium`
        margin-top: -30px;
    `};
    padding: 5px;
    position: absolute;
`

export const CartToastComponent = injectIntl(CartToast)
